"use client";

import React from "react";
import styles from "./drop-down.module.scss";

export interface DropDownItem<ValueType>
{
  value: ValueType;
  title: string;
  selected: boolean;
}

export type OnDropDownItemSelect<ValueType> = (item: DropDownItem<ValueType>) => void;

export interface DropDownBaseProps<ValueType>
{
  items: DropDownItem<ValueType>[];
  onItemSelect: OnDropDownItemSelect<ValueType>;
}

export const DropDownBase = <ValueType,>({ items, onItemSelect }: DropDownBaseProps<ValueType>): React.FunctionComponentElement<DropDownBaseProps<ValueType>> =>
{
  const handleClicked = React.useCallback<React.MouseEventHandler<HTMLUListElement>>(event =>
  {
    event.preventDefault();
    event.stopPropagation();

    const item = event.target as HTMLLIElement;
    const itemIndex = Number(item.dataset["value"]);

    onItemSelect(items[itemIndex]);

  }, [items, onItemSelect]);

  return (
    <div className={styles["drop-down"]}>
      <ul onClick={handleClicked}>
        {
          items.map((e, i) => <li data-selected={e.selected} data-value={i} key={i}>{e.title}</li>)
        }
      </ul>
    </div>
  );
};
